// DO NOT EDIT
  // this file is generated by /internals/populate-icons script
  import * as React from 'react'
  // @ts-ignore
  import { Check } from 'react-feather'
  import IconBase from './../../IconBase'

  function IconCheck(props: any) {
    return <IconBase icon={Check} {...props} />
  }

  export default IconCheck
  